<script setup lang="ts">
/**
 *
 *  Props and emits section
 *
 *
 */

defineProps<{
    title: string
    customBanner?: string
    customBgBanner?: string
    customBannerMobile?: string
    withoutBackground?: boolean
}>()

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

/**
 *
 *  Life cicle events
 *
 *
 */

/**
 *
 *  Functions section
 *
 *
 */
</script>

<template>
    <div
        v-if="customBanner"
        :class="`tw-w-full tw-flex tw-items-center tw-justify-center ${customBanner ? 'tw-h-40 lg:tw-h-60' : 'tw-h-60'} tw-overflow-hidden`"
    >
        <picture class="tw-w-full tw-h-full">
            <source
                media="(max-width: 744px)"
                :srcset="customBannerMobile"
                class="tw-w-full tw-h-full"
            />
            <img :src="customBanner" alt="" class="tw-w-full tw-h-full" />
        </picture>
    </div>
    <div
        v-else-if="!customBanner && title"
        :class="`tw-w-full ${!withoutBackground && `${customBgBanner || 'bg-banner'}`} tw-relative tw-flex tw-items-center tw-justify-center tw-h-60 md:tw-h-40 tw-overflow-hidden tw-p-2`"
    >
        <h2
            class="tw-font-semibold tw-text-white tw-max-w-max tw-text-[32px] md:tw-text-[40px] tw-leading-[48px] md:tw-leading-[60px] tw-text-center"
        >
            {{ title }}
        </h2>
    </div>
</template>

<style>
.bg-banner {
    background: #7fb2eb;
}

.bg-banner::before {
    content: "";
    width: 100px;
    height: 100px;
    position: absolute;
    left: 0;
    bottom: 0;
    margin-top: auto;
    aspect-ratio: 1 / 1;
    transform: scale(2.5);
    background: url("/img/banner-img.svg") no-repeat;
    background-size: contain;
}

.bg-banner::after {
    content: "";
    width: 100px;
    height: 100px;
    position: absolute;
    right: 0;
    bottom: 0;
    margin-top: auto;
    aspect-ratio: 1 / 1;
    transform: rotateY(180deg) scale(2.5);
    background: url("/img/banner-img.svg") no-repeat;
    background-size: contain;
}

@media screen and (min-width: 768px) {
    .bg-banner::before {
        content: "";
        width: 150px;
        height: 100%;
        position: absolute;
        left: 110px;
        top: 0;
        bottom: 0;
        aspect-ratio: 1 / 1;
        transform: scale(2.5);
        background: url("/img/banner-img.svg") no-repeat;
        background-size: contain;
    }

    .bg-banner::after {
        content: "";
        width: 150px;
        height: 100%;
        position: absolute;
        right: 110px;
        top: 0;
        bottom: 0;
        aspect-ratio: 1 / 1;
        transform: rotateY(180deg) scale(2.5);
        background: url("/img/banner-img.svg") no-repeat;
        background-size: contain;
    }
}
</style>
